<template>
  <section
    class="login-content live-login-content"
    :style="{
      background: 'url(' + liveBgImg + ')',
      backgroundSize: '100% 100%',
    }"
  >
    <div
      class="login-main"
      :style="{
        background: 'url(' + liveMainImg + ')',
        backgroundSize: '100% 100%',
      }"
    >
      <div class="login_box">
        <h1>公开课课件</h1>
        <switchdentity @dentityEvent="getUserType"></switchdentity>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
          <el-form-item prop="username">
            <el-input
              prefix-icon="el-icon-user-solid"
              type="text"
              v-model="ruleForm.username"
              autocomplete="off"
              placeholder="请输入用户名"
            >
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              prefix-icon="el-icon-user-solid iconfont icon-mima"
              type="password"
              v-model="ruleForm.password"
              placeholder="请输入密码"
              autocomplete="off"
            >
            </el-input>
          </el-form-item>
          <el-form-item prop="code" class="codeImg">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-input
                  v-model="ruleForm.code"
                  placeholder="请输入验证码"
                ></el-input>
              </el-col>
              <el-col :span="6">
                <img @click="ImgRefresh" :src="codePic" alt="" />
              </el-col>
              <el-col :span="6">
                <!-- <span @click="forgetPass">忘记密码</span> -->
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item>
            <el-row :gutter="24">
              <el-button
                class="loginBtn"
                type="primary"
                @click="submitForm('ruleForm')"
                >登录
              </el-button>
            </el-row>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </section>
</template>

<script>
import switchdentity from "@/components/switchDentity";
import api from "../request/service/openClassApi";
import axios from "axios";
export default {
  name: "liveLogin",
  //import引入的组件需要注入到对象中才能使用
  components: {
    switchdentity,
  },
  data() {
    return {
      liveBgImg: require("@/assets/images/dengl_live_bg.png"),
      liveMainImg: require("@/assets/images/dengl_live_main.png"),
      codePic: "",
      loginUserType: "2", //用户类型 默认2 老师
      ruleForm: {
        username: "",
        password: "",
        code: "",
      },
      rules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" },
          {
            min: 8,
            max: 20,
            message: "用户名由8-20位的英文字母数字符号组成",
            trigger: "blur",
          },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            min: 6,
            max: 20,
            message: "密码由6-20位的字母数字符号组成",
            trigger: "blur",
          },
        ],
        // mobile: [{ validator: isvalidPhone, trigger: "blur" }],
        code: [
          {
            required: true,
            message: "验证码错误",
            trigger: "blur",
          },
        ],
      },
      isLogin: false,
    };
  },
  //监听属性类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  created: function () {
    this.ImgRefresh();
  },
  //方法集合
  methods: {
    // ...mapMutations(["storeLogin"]),
    ImgRefresh() {
      var number = new Date().getTime();
      axios
        .get(this.$url + "/getRandomPicture.app?number=" + number, {
          responseType: "arraybuffer",
          withCredentials: true,
        })
        .then((response) => {
          return (
            "data:image/png;base64," +
            btoa(
              new Uint8Array(response.data).reduce(
                (data, byte) => data + String.fromCharCode(byte),
                ""
              )
            )
          );
        })
        .then((data) => {
          this.codePic = data;
        });
    },
    // 获取登录用户类型
    getUserType(val) {
      this.loginUserType = val;
    },
    getcode() {},
    submitForm(formName) {
      let _this = this;
      let username = _this.ruleForm.username;
      let password = _this.$md5(_this.ruleForm.password);
      let code = _this.ruleForm.code;
      let loginUserType = this.loginUserType;
      let userForm = {
        username,
        password,
        code,
        loginUserType,
      };
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$store.dispatch("Login", userForm).then((res) => {
            console.log("值", res);
            if (res.status == "y") {
              this.$router.push({ name: "liveCourseWare" });
            } else {
              this.ImgRefresh();
              this.ruleForm.code = "";
            }
            //  this.ruleForm.username='';
            // this.ruleForm. password='';
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>
<style lang='less'>
.login-content {
  // background: url(../assets/images/dengl_school_bg.png) center no-repeat;
  padding: 100px 0 80px;

  .login-main {
    width: 1012px;
    height: 600px;
    margin: 0 auto;
    border-radius: 0.2rem;
    box-sizing: border-box;
    padding: 0.12rem;
    display: flex;
    flex-direction: row;
    position: relative;

    .login_box {
      width: 461px;
      padding: 87px 61px;
      box-sizing: border-box;
      position: absolute;
      top: 0;
      right: 0;

      h1 {
        color: #fba5bd;
        font-size: 28px;
        text-align: left;
        padding-bottom: 31px;
      }

      .el-form {
        padding-top: 24px;

        .codeImg {
          img {
            height: 38px;
          }

          span {
            color: #fba5bd;
          }
        }

        .el-button {
          width: 100%;
          height: 50px;
          border-radius: 30px;
          background: #fba5bd;
          border: none;
        }
      }

      .el-form-item {
        margin-bottom: 24px;
      }

      .el-input__inner {
        border-radius: 28px;
      }
    }
  }
}
</style>